import { SessionStatus } from '@sunrise-ui/api/events/api';
import { useMemo } from 'react';
import { useGetSessionsByEventId } from '../queries/sessions';

/**
 * Hook to check if an event has any sessions in scheduled status
 */
export const useEventHasScheduledSessions = (eventId?: string) => {
  const { data: sessions, isLoading } = useGetSessionsByEventId(eventId);

  const hasScheduledSessions = useMemo(() => {
    if (!sessions) return false;
    return sessions.some(
      (session) =>
        session.status === SessionStatus.Scheduled ||
        session.status === SessionStatus.Confirmed,
    );
  }, [sessions]);

  return {
    hasScheduledSessions,
    isLoading,
  };
};
